
import React from "react";

// reactstrap components
import {
  NavItem,
  NavLink,
  Nav,
  TabContent,
  TabPane,
  Container,
  Row,
  Col,
} from "reactstrap";

// core components
import ServicesNavbar from "components/Navbars/ServicesNavbar.js";
import ProfilePageHeader3 from "components/Headers/ProfilePageHeader3.js";
import DemoFooter from "components/Footers/DemoFooter.js";

function ProfilePage3() {
  const [activeTab, setActiveTab] = React.useState("1");

  const toggle = (tab) => {
    if (activeTab !== tab) {
      setActiveTab(tab);
    }
  };

  document.documentElement.classList.remove("nav-open");
  React.useEffect(() => {
    document.body.classList.add("landing-page");
    return function cleanup() {
      document.body.classList.remove("landing-page");
    };
  });
  return (
    <>
      <ServicesNavbar />
      <ProfilePageHeader3 />
      <div className="section profile-content">
        <Container>
          <div className="owner">
            <div className="avatar">
              <img
                alt="..."
                className="img-circle img-no-padding img-responsive"
                src={require("assets/img/faces/ninaprofile.jpg").default}
              />
            </div>
            <div className="name">
              <h4 className="title">
                Nina Seifeddine<br />
              </h4>
              <h6 className="description" style={{color:"black"}}> Head of Graphic Design Department </h6>
            </div>
          </div>
          <Row>
            <Col className="ml-auto mr-auto text-center" md="6">
              <p style={{color:"black"}}>
              Inspiration is a huge part of graphic design. 
              You need to have a great idea to start with, an aesthetic 
              to draw inspiration from, and the motivation to get the job done.
              </p>
              <br />
              
            </Col>
          </Row>
          <br />
          <div className="nav-tabs-navigation">
            <div className="nav-tabs-wrapper">
              <Nav role="tablist" tabs>
                <NavItem>
                  <NavLink
                    className={activeTab === "1" ? "active" : ""}
                    onClick={() => {
                      toggle("1");
                    }}
                  >
                    Contact Info
                  </NavLink>
                </NavItem>
                <NavItem>
                  <NavLink
                    className={activeTab === "2" ? "active" : ""}
                    onClick={() => {
                      toggle("2");
                    }}
                  >
                    Quote
                  </NavLink>
                </NavItem>
              </Nav>
            </div>
          </div>
          {/* Tab panes */}
          <TabContent className="following" activeTab={activeTab}>
            <TabPane tabId="1" id="follows">
              <Row>
                <Col className="ml-auto mr-auto" md="6">
                  <ul className="">
                    <li>
                      <Row>
                        <Col className="ml-auto mr-auto" lg="2" md="4" xs="4">
                        <i className="fa fa-envelope" /> 

                        </Col>
                        <Col className="ml-auto mr-auto" lg="7" md="4" xs="4">
                          <h6>
                            Mail <br />
                            <small style={{color:"black"}}>nina.seifeddine@hotmail.com</small>
                          </h6>
                        </Col>
                        <Col className="ml-auto mr-auto" lg="3" md="4" xs="4">
                          
                        </Col>
                      </Row>
                    </li>
                    <hr />
                    <li>
                      <Row>
                        <Col className="mx-auto" lg="2" md="4" xs="4">
                        <i className="fa fa-linkedin" /> 

                          
                        </Col>
                        <Col lg="7" md="4" xs="4">
                          
                        <h6>
                            LinkedIn <br />
            
                            <a  
              href="https://www.linkedin.com/in/nina-seif-eddine-612581216"
              target="_blank"
              rel="noreferrer"
              
            ><small style={{color:"black"}}> Nina Seifeddine</small></a>
                      
                          </h6>
                      
                        </Col>
                        <Col lg="3" md="4" xs="4">
                          
                        </Col>
                      </Row>
                    </li>
                  </ul>
                </Col>
              </Row>
            </TabPane>
            <TabPane className="text-center" tabId="2" id="following">
            <blockquote className="blockquote">
            <p className="mb-0" style={{color:"black"}}>
            "The best way to predict the future is to create it."             
              </p>
            <br />
            <footer className="blockquote-footer" style={{color:"black"}}>
              {" "}
              <cite title="source Title" style={{color:"black"}}>Peter Drucker</cite>
            </footer>
          </blockquote>
            </TabPane>
          </TabContent>
        </Container>
      </div>
      <DemoFooter />
    </>
  );
}

export default ProfilePage3;
